export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ23.b3d91e65.mp3";